export interface Tema {
  nome: string;
  propriedades: Record<string, string>;
}

export const TemaClaro: Tema = {
  nome: "Claro",
  propriedades: {
    "--tom-bg-portal": "var(--grey-100)",
    "--tom-text-portal": "black",
    "--tom-bg-secundario-portal": "var(--grey-400)",
    "--tom-1-jornal": "var(--main-red)",
    "--bg-bar-search-input": "var(--grey-400)",
    "--bg-fale-conosco-envio-email": "var(--grey-400)",
    "--text-label-title-input-field": "var(--secondary-yellow)",
    "--text-geral-fundo-claro": "var(--grey-900)",
    "--text-geral-fundo-escuro": "var(--grey-100)",
    "--text-global-html-tags": "var(--grey-900)",
    "--accordeon-background": "white",
    "--breadcrump-bg": "var(--grey-300)",
    "--general-bg": "white",
    "--sidebar-item-bg": "white",
    "--sidebar-article-bg": "white",
    "--tom-bg-escuro-portal": "#231f20",
    "--cal-tela-publicacao-bg-dias-semana": "#7B707080",
    "--text-secondary-red" : "#AE1917"
  }
}

export const TemaEscuro: Tema = {
  nome: "Escuro",
  propriedades: {
    "--tom-bg-portal": "#141011",
    "--tom-text-portal": "var(--grey-100)",
    "--tom-bg-secundario-portal": "var(--grey-800)",
    "--tom-1-jornal": "pink",
    "--bg-bar-search-input": "var(--grey-400)",
    "--bg-fale-conosco-envio-email": "var(--grey-400)",
    "--text-label-title-input-field": "var(--secondary-yellow)",
    "--text-geral-fundo-claro": "var(--grey-100)",
    "--text-geral-fundo-escuro": "var(--grey-900)",
    "--text-global-html-tags": "var(--grey-100)",
    "--accordeon-background": "black",
    "--breadcrump-bg": "var(--grey-900)",
    "--general-bg": "black",
    "--sidebar-item-bg": "black",
    "--sidebar-article-bg": "black",
    "--tom-bg-escuro-portal": "white",
    "--cal-tela-publicacao-bg-dias-semana": "white",
    "--text-secondary-red" : "var(--grey-100)"
  }
}
